<div class="form-container">
  <!--FORM HEADING-->
  <ng-container *ngIf="formHeading">
    <h3 class="text-align-center margin-bottom-small">{{ formHeading }}</h3>
  </ng-container>
  <!--END FORM HEADING-->

  <!--REQUEST FORM-->
  <form class="header-request-form" [formGroup]="requestDemoForm" (ngSubmit)="onRequestForm()">
    <fieldset>
      <div class="request-form-row">
        <!--FIRSTNAME FIELD-->
        <div class="request-form-column">
          <label for="form-first-name">First Name <span>*</span></label>
          <input
            id="form-first-name"
            type="text"
            placeholder="First Name"
            formControlName="firstname"
            class="form-control"
            [ngClass]="{ 'is-invalid': submitted && formControl.firstname.errors }"
            required />
          <div *ngIf="submitted && formControl.firstname.errors" class="invalid-value">
            <div *ngIf="formControl.firstname.errors.required">First Name is required</div>
          </div>
        </div>
        <!--END FIRSTNAME FIELD-->

        <!--LASTNAME FIELD-->
        <div class="request-form-column">
          <label for="form-last-name">Last Name <span>*</span></label>
          <input
            id="form-last-name"
            type="text"
            placeholder="Last Name"
            formControlName="lastname"
            class="form-control"
            [ngClass]="{ 'is-invalid': submitted && formControl.lastname.errors }"
            required />
          <div *ngIf="submitted && formControl.lastname.errors" class="invalid-value">
            <div *ngIf="formControl.lastname.errors.required">Last Name is required</div>
          </div>
        </div>
        <!--END LASTNAME FIELD-->
      </div>

      <div class="request-form-row">
        <!--EMAIL FIELD-->
        <div class="request-form-column">
          <label for="form-email">Email <span>*</span></label>
          <input
            type="email"
            placeholder="Email"
            formControlName="email"
            [ngClass]="{ 'is-invalid': submitted && formControl.email.errors }" />
          <div *ngIf="submitted && formControl.email.errors" class="invalid-value">
            <div *ngIf="formControl.email.errors.required">Email is required</div>
            <div *ngIf="formControl.email.errors.email">Email must be a valid email address</div>
          </div>
        </div>
        <!--END EMAIL FIELD-->

        <!--PHONE FIELD-->
        <div class="request-form-column">
          <label for="form-phone">Phone <span>*</span></label>
          <input
            type="text"
            placeholder="Phone"
            formControlName="phone"
            [ngClass]="{ 'is-invalid': submitted && formControl.phone.errors }" />
          <div *ngIf="submitted && formControl.phone.errors" class="invalid-value">
            <div *ngIf="formControl.phone.errors.required">Phone is required</div>
            <div *ngIf="formControl.phone.errors.pattern">Phone must be numeric</div>
          </div>
        </div>
        <!--END PHONE FIELD-->
      </div>

      <div class="request-form-row">
        <!--COUNTRY FIELD-->
        <div class="request-form-column">
          <label for="form-countries">Country</label>
          <select
            formControlName="countryControl"
            placeholder="Country"
            (change)="onChangeCountry($event.target.value)">
            <option
              *ngFor="let country of countries; let i = index; trackBy: trackByCountryTitle"
              value="{{ i }}">
              {{ country.CountryName }}
            </option>
          </select>
        </div>
        <!--END COUNTRY FIELD-->

        <!--STATE FIELD-->
        <div class="request-form-column">
          <label for="form-states">State</label>
          <select formControlName="stateControl" placeholder="State">
            <option
              *ngFor="let state of stateInfo; let j = index; trackBy: trackByStateTitle"
              value="{{ j }}">
              {{ state.StateName }}
            </option>
          </select>
        </div>
        <!--END STATE FIELD-->
      </div>

      <!--COMPANY FIELD-->
      <label for="form-company">Company Name</label>
      <input type="text" placeholder="Company Name" formControlName="company" />
      <!--END COMPANY FIELD-->

      <!--SUBMIT ERROR MESSAGE-->
      <p class="errormsg" *ngIf="showError">
        There was an error processing your request. Please try again later. If the problem persists,
        email <span style="white-space: nowrap">beyond-registration&#64;genesys.com</span> for
        quotation&nbsp;assistance.
      </p>
      <!--END SUBMIT ERROR MESSAGE-->

      <!--SUBMIT BUTTON-->
      <input class="btn btn-primary margin-top-large" type="submit" value="Submit" />
      <!--END SUBMIT BUTTON-->
    </fieldset>
  </form>
  <!--END REQUEST FORM-->
</div>
